import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { ArrayHelpers } from "../../helpers/array.helpers";
import { Row } from "../../models/basic/row.model";
import { RequestOptions } from "../../models/rest/requestoptions";
import { DataPreviewService } from "../../services/data.preview.service";
import { DataSettingsService } from "../../services/data.settings.service";
import { DataModelService } from "../../services/datamodel.service";
import { IntegrationWizardFinishPage } from "../integrationwizard/iw.finish.page";
import { IntegrationWizardMigrationPage } from "../integrationwizard/iw.migration.page";
import { IntegrationWizardSummaryPage } from "../integrationwizard/iw.summary.page";
import { IntegrationWizardUploadPage } from "../integrationwizard/iw.upload.page";

@Component({
    selector: 'integration-control',
    templateUrl: './integration.control.html',
    styleUrls: ['./integration.control.css']
})
export class IntegrationControl implements OnInit {
    AllTables = [];
    StartWizard = false;
    valList: any[] = [
        { Caption: "@@IC-GA-Int-Upload-Files", Content: IntegrationWizardUploadPage, disabled: false },
        { Caption: "@@IC-GA-Int-Migrating-Database", Content: IntegrationWizardMigrationPage, disabled: true },
        { Caption: "@@IC-GA-Int-Summary", Content: IntegrationWizardSummaryPage, disabled: true },
        { Caption: "@@IC-GA-Int-Finish", Content: IntegrationWizardFinishPage, disabled: true }
    ];

    //static GetMenuEntry() {
    //    return {
    //        Caption: '@@IC-GA-Int-Navigation',
    //        ID: 'integrationControl',
    //        Icon: 'integration_dashboard_add',
    //        Index: 20,
    //        URL: '/integration/data'
    //    };
    //}

    constructor( private preview: DataPreviewService, private cdRef: ChangeDetectorRef, private dmService: DataModelService, private dsService: DataSettingsService) {
    }

    ngOnInit(): void {
        // Call the GetModels method from dmService to fetch models
        this.dmService.GetModels().subscribe(x => {
            // Check if the response contains models
            if (x) {
                // Iterate over each model
                x.forEach((model: any) => {
                    // For each model, fetch its associated tables using GetContainerTables
                    this.dsService.GetContainerTables(model.SID).subscribe(tables => {
                        // Check if the response contains tables
                        if (tables) {
                            // Merge the fetched tables with existing AllTables
                            const newTables = [...this.AllTables, ...tables];
                            // Sort the combined tables alphabetically by their 'Caption'
                            ArrayHelpers.sortAlphabetical(newTables, 'Caption');
                            // Update the AllTables property with the sorted tables
                            this.AllTables = newTables;
                            // Trigger change detection to update the view
                            this.cdRef.detectChanges();
                        }
                    });
                });
            }
        });
    }


    cols: any;

    get Columns() {
        if (this.cols) {
            return this.cols;
        }

        const myObject = [{
            TranslatedCaption: 'Select a table above to see a preview'
        }];

        return myObject;
    }

    vals: any;

    get Values() {
        if (this.vals) {
            return this.vals;
        }
    }

    onTableChange(ev: any) {
        // Check if the event object is valid
        if (ev) {
            let SID = ev.SID;
            // Fetch table content using the SID
            this.dmService.GetContainer(SID).subscribe(result => {
                // Check if the result is valid
                if (result) {
                    // Set columns based on the fetched result
                    this.cols = result.Fields;
                    // Initialize a filter for the query
                    const filter = RequestOptions.CleanRequestOptions();
                    filter['Top'] = 20; // Limit the result to top 20 rows

                    // Execute a query to get a preview of the table data
                    this.preview.ExecuteQuery(SID, filter).subscribe(val => {
                        // Check if the returned value is an array
                        if (Array.isArray(val)) {
                            // Check if the array is not empty
                            if (val.length > 0) {
                                const pd = []; // Prepare an array to hold processed data
                                let count = 0;
                                // Iterate over each row in the returned value
                                val.forEach((row) => {
                                    const toPush = new Row(); // Create a new Row object
                                    toPush.index = count++; // Set the index for the row
                                    toPush.data = row; // Assign the row data
                                    pd.push(toPush); // Add the row to the processed data array
                                });
                                this.vals = pd; // Set the vals property to the processed data
                            } else {
                                // If the array is empty, set vals to the returned value
                                this.vals = val;
                            }
                        } else {
                            // If the returned value is not an array, set vals to an empty array
                            this.vals = [];
                        }
                    });
                }
            });

            // Todo: Apply the table content to a list
        }
    }

}
